<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span class="pr-2 mr-2 font-bold text-2xl">
        Retur - {{ id > 0 ? 'Edit' : 'Tambah' }}
      </span>
      <div>
        <i class="pi pi-home mr-2"></i>
        <span class="font-small">
          / Pembelian / Retur / {{ id > 0 ? 'Edit' : 'Tambah' }}
        </span>
      </div>
    </div>
    <form @submit.prevent="save(!v$.$invalid)">
      <div class="card bg-white">
        <div class="flex justify-content-end mb-2">
          <Button
            :loading="isLoadingSave"
            icon="pi pi-save"
            class="mr-2"
            :label="id > 0 ? 'Update' : 'Simpan'"
            type="submit"
          />
          <Button
            :disabled="old_status_value === 'done'"
            icon="pi pi-plus"
            class="p-button-outlined mr-2"
            label="Item"
            @click="onAddData"
          />
          <div>
            <Button
              icon="pi pi-plus"
              class="p-button-outlined mr-2"
              label="Item Non Penerimaan"
              @click="onAddDataNonPenerimaan"
            />
          </div>
          <Button
            class="p-button-link"
            label="Kembali"
            @click="$router.push({ name: 'PurchaseRetur' })"
          />
        </div>
        <div class="grid">
          <div class="col-12 md:col-8">
            <div class="formgrid grid">
              <div class="field col-12 md:col-4">
                <label>Tgl Retur</label>
                <Calendar
                  v-model="form.rt_at"
                  dateFormat="dd/mm/yy"
                  class="w-full"
                  input-class="w-full"
                />
              </div>
              <div class="field col-12 md:col-4">
                <label>No Retur</label>
                <InputText
                  v-model="form.rt_no"
                  class="w-full"
                  input-class="w-full"
                  maxlength="50"
                  disabled
                />
              </div>
              <div class="field col-12 md:col-4">
                <label>Ref No</label>
                <InputText
                  v-model="form.ref_no"
                  class="w-full"
                  input-class="w-full"
                  maxlength="50"
                />
              </div>
              <div class="field col-12 md:col-4">
                <label>Supplier</label>
                <Dropdown
                  ref="supplierDropdown"
                  v-model="form.supp_id"
                  :filter="true"
                  :options="list_supplier"
                  class="w-full"
                  input-class="w-full"
                  optionValue="id"
                  optionLabel="name"
                  placeholder="Pilih Supplier"
                  :disabled="id"
                  :class="{
                    'p-invalid': v$.form.supp_id.$invalid && submitted,
                  }"
                />
                <small
                  v-if="
                    (v$.form.supp_id.$invalid && submitted) ||
                    v$.form.supp_id.$pending.$response
                  "
                  class="p-error"
                  >{{ v$.form.supp_id.required.$message }}</small
                >
              </div>
              <div class="field col-12 md:col-4">
                <label>Status</label>
                <Dropdown
                  v-model="form.status"
                  :options="list_status"
                  :disabled="!id || old_status_value === 'done'"
                  optionValue="value"
                  optionLabel="label"
                  optionDisabled="disabled"
                  class="w-full"
                  input-class="w-full"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <fx-table
            :items="form.details"
            :total="form.details.length"
            :loading="isLoading"
            :paginator="false"
            hasFooter
            showGridlines
            :editMode="old_status_value !== 'done' ? 'cell' : null"
            @cell-edit-complete="onCellEditComplete"
          >
            <template #columns>
              <Column
                field="rcv_no"
                header="NO Penerimaan"
                style="min-width: 15rem; background-color: #f8f9fa"
              />
              <Column
                field="pr_no"
                header="NO Pembelian"
                style="min-width: 15rem; background-color: #f8f9fa"
              />
              <Column
                field="item_sku"
                header="SKU"
                style="min-width: 8rem; background-color: #f8f9fa"
              />
              <Column
                field="item_barcode_1"
                header="Barcode"
                style="min-width: 8rem; background-color: #f8f9fa"
              />
              <Column
                field="item_name"
                header="Deskripsi"
                style="min-width: 12rem; background-color: #f8f9fa"
              />

              <Column
                field="unit_b"
                header="Satuan"
                style="min-width: 6rem; background-color: #f8f9fa"
              >
                <template #body="slotProps">
                  {{ slotProps.data.unit_b }}.{{ slotProps.data.unit_s }}
                </template>
              </Column>
              <Column
                field="ubox"
                header="ISI"
                style="
                  min-width: 6rem;
                  background-color: #f8f9fa;
                  justify-content: flex-end;
                "
              />
              <Column
                field="qty_b"
                header="qty (b)"
                style="min-width: 6rem; justify-content: flex-end"
              >
                <template #editor="{ data, field }">
                  <InputText
                    :model-value="data[field]"
                    class="w-full text-right"
                    autofocus
                    @focus="$event.target.select()"
                    @update:model-value="data[field] = $event"
                    @keydown.enter.prevent="handleEnter(data, field, $event)"
                  />
                </template>
              </Column>
              <Column
                field="qty_s"
                header="qty (s)"
                style="min-width: 6rem; justify-content: flex-end"
              >
                <template #editor="{ data, field }">
                  <InputText
                    :model-value="data[field]"
                    class="w-full text-right"
                    autofocus
                    @focus="$event.target.select()"
                    @update:model-value="data[field] = $event"
                    @keydown.enter.prevent="handleEnter(data, field, $event)"
                  />
                </template>
              </Column>
              <Column
                field="qty"
                header="QTY (PCS)"
                style="
                  min-width: 8rem;
                  background-color: #f8f9fa;
                  justify-content: flex-end;
                "
              >
              </Column>

              <Column
                field="cost"
                header="Harga"
                style="min-width: 10rem; justify-content: flex-end"
              >
                <template #body="slotProps">
                  <span style="text-align: right">
                    {{ formatCurrency(slotProps.data.cost, 2, 2) }}
                  </span>
                </template>
                <template #editor="{ data, field }">
                  <div class="p-inputgroup flex-1 w-full">
                    <span class="p-inputgroup-addon">Rp</span>
                    <InputText
                      :model-value="data[field]"
                      class="w-full text-right"
                      autofocus
                      @focus="$event.target.select()"
                      @update:model-value="data[field] = $event"
                      @keydown.enter.prevent="handleEnter(data, field, $event)"
                    />
                  </div>
                </template>
              </Column>

              <Column
                field="cost_s"
                header="Harga (Net)"
                style="min-width: 10rem; justify-content: flex-end"
              >
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.cost_s || 0, 2, 2) }}
                </template>
              </Column>

              <Column
                field="cost_per"
                header="PER"
                style="
                  min-width: 5rem;
                  background-color: #f8f9fa;
                  justify-content: flex-start;
                "
              >
              </Column>

              <Column
                field="disc_reg"
                header="DISC.REG"
                style="
                  min-width: 8rem;
                  background-color: #f8f9fa;
                  justify-content: flex-end;
                "
              >
                <template #body="slotProps">
                  {{
                    slotProps.data.disc_reg > 100
                      ? formatCurrency(slotProps.data.disc_reg, 0, 0)
                      : `${formatPercentage(slotProps.data.disc_reg || 0, 0, 0)}%`
                  }}
                </template>
              </Column>
              <Column
                field="disc_ext"
                header="DISC.EXT"
                style="
                  min-width: 8rem;
                  background-color: #f8f9fa;
                  justify-content: flex-end;
                "
              >
                <template #body="slotProps">
                  {{
                    slotProps.data.disc_ext > 100
                      ? formatCurrency(slotProps.data.disc_ext || 0, 0, 0)
                      : `${formatPercentage(slotProps.data.disc_ext || 0, 0, 0)}%`
                  }}
                </template>
              </Column>
              <Column
                field="tax"
                header="PPN"
                style="
                  min-width: 8rem;
                  max-width: 8rem;
                  background-color: #f8f9fa;
                  justify-content: flex-end;
                "
              >
                <template #body="slotProps">
                  {{ `${slotProps.data.tax || 0}%` }}
                </template>
              </Column>
              <Column
                field="dpp"
                header="Jumlah NET (-PPN)"
                style="
                  min-width: 12rem;
                  max-width: 12rem;
                  background-color: #f8f9fa;
                  justify-content: flex-end;
                "
              >
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.dpp, 2, 2) }}
                </template>
              </Column>

              <!-- <Column
                field="ppn"
                header="PPN"
                style="
                  min-width: 12rem;
                  max-width: 12rem;
                  background-color: #f8f9fa;
                "
              >
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.ppn, 0, 0) }}
                </template>
              </Column> -->

              <Column style="flex-grow: 1; justify-content: flex-end">
                <template #body="{ data }">
                  <Button
                    type="button"
                    icon="pi pi-pencil"
                    class="
                      p-button-outlined p-button-secondary p-button-text
                      mr-2
                    "
                    :disabled="old_status_value === 'done'"
                    @click="onEditData(data)"
                  />
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    :disabled="old_status_value === 'done'"
                    class="p-button-outlined p-button-danger p-button-text"
                    @click="onConfirmDeletion(data)"
                  />
                </template>
              </Column>
            </template>
            <template #footer>
              <table class="flex justify-content-end text-grey-200">
                <tr>
                  <td width="100%">
                    <table class="justify-content-end text-700">
                      <tr>
                        <td>SUB TOTAL</td>
                        <td style="width: 150px" class="text-right">
                          {{ formatCurrency(totalPO.bruto || 0, 2, 2) }}
                        </td>
                      </tr>
                      <tr>
                        <td>DISC REGULER</td>
                        <td class="text-right">
                          {{ formatCurrency(totalPO.disc_reg || 0, 2, 2) }}
                        </td>
                      </tr>
                      <tr>
                        <td>DISC EXTRA</td>
                        <td class="text-right">
                          {{ formatCurrency(totalPO.disc_ext || 0, 2, 2) }}
                        </td>
                      </tr>
                      <tr>
                        <td>PPN</td>
                        <td class="text-right">
                          {{ formatCurrency(totalPO.ppn, 0, 0 || 0) }}
                        </td>
                      </tr>
                      <tr>
                        <td>GRAND TOTAL</td>
                        <td class="text-right">
                          {{ formatCurrency(totalPO.total || 0, 2, 2) }}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </template>
          </fx-table>
        </div>
      </div>
    </form>
    <Dialog
      :header="'Tambah Item Retur'"
      v-model:visible="dialog"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '95vw' }"
      :modal="true"
      :maximizable="true"
    >
      <form-purchase-retur
        :purchaseOrder="list_purchase_order"
        :excludeList="list_produk"
        :listSatuan="list_satuan"
        :editMode="editMode"
        @save="onSaveData"
        @close="dialog = false"
      />
    </Dialog>
    <Dialog
      header="Edit Item Retur"
      v-model:visible="dialogItem"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
      :maximizable="true"
    >
      <form-purchase-order
        :item="formDetail"
        :qtyB="originalQtyB"
        :qtyS="originalQtyS"
        :loading="isLoadingSave"
        :list-satuan="list_satuan"
        :purchase-order="PurchaseOrder"
        :editMode="editMode"
        onMenu="retur"
        @save="onSaveDataItem"
        @close="dialogItem = false"
      />
    </Dialog>
    <Dialog
      header="Item Retur Non Penerimaan"
      v-model:visible="dialogNonPenerimaan"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
      :maximizable="true"
    >
      <form-purchase-order
        :item="formDetail"
        :loading="isLoadingSave"
        :list-satuan="list_satuan"
        :editMode="false"
        onMenu="retur"
        @save="onSaveDataItemNonPenerimaan"
        @close="dialogNonPenerimaan = false"
      />
    </Dialog>
    <Dialog
      header="Perubahan Supplier"
      v-model:visible="dialogSupplier"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '40vw' }"
      :modal="true"
      :closable="false"
    >
      <div class="confirmation-content">
        <span>Item yang sudah diinput berbeda supplier, Ulangi Input ?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text p-button-secondary"
          @click="onNoSupplier(this.old_supplier_id)"
        />
        <Button label="Yes" @click="onYesSupplier" />
      </template>
    </Dialog>
    <Dialog
      header="Hapus Retur"
      v-model:visible="dialogHapus"
      :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
      :style="{ width: '50vw' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <span
          >Item Retur <strong>{{ formDetail.item_name }}</strong> akan dihapus.
          Proses ?</span
        >
      </div>
      <template #footer>
        <Button
          label="Hapus"
          icon="pi pi-trash"
          @click="onDeleteItemPurchaseOrder"
          class="p-button-text p-button-danger"
        />
      </template>
    </Dialog>
    <hotkey :shortcuts="['D']" @triggered="onTriggerHotkey" />
  </div>
</template>

<script>
import FxTable from '@/components/FxTable'
import Hotkey from '@/components/Hotkey'
import FormPurchaseOrder from '@/components/pembelian/FormPurchaseOrder'
import FormPurchaseRetur from '@/components/pembelian/FormPurchaseRetur'
import errorHandler from '@/helpers/error-handler'
import { ceiling, formatCurrency, formatPercentage } from '@/helpers/index'
import PurchaseReceiveService from '@/services/PurchaseReceiveService'
import PurchaseReturService from '@/services/PurchaseReturService'
import SatuanService from '@/services/SatuanService'
import SettingService from '@/services/SettingService'
import SupplierService from '@/services/SupplierService'
import useVuelidate from '@vuelidate/core'
import { helpers, required } from '@vuelidate/validators'
import dayjs from 'dayjs'
import { FilterMatchMode } from 'primevue/api'
export default {
  setup: () => ({ v$: useVuelidate() }),
  name: 'PurchaseRetur',
  components: {
    FormPurchaseOrder,
    FormPurchaseRetur,
    FxTable,
    Hotkey,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
      submitted: false,
      settingService: null,
      satuanService: null,
      supplierService: null,
      purchaseReceiveService: null,
      purchaseReturService: null,
      dialog: false,
      dialogItem: false,
      dialogHapus: false,
      dialogSupplier: false,
      dialogNonPenerimaan: false,
      isLoading: false,
      isLoadingItem: false,
      isLoadingSave: false,
      editMode: false,
      old_status_value: 'draft',
      old_supplier_id: 0,
      items: [],
      list_supplier: [],
      list_term: [],
      list_satuan: [],
      list_items: [],
      list_purchase_order: [],
      list_detail_receive: [],
      form: {
        rt_no: '',
        rt_at: new Date(),
        ref_no: '',
        supp_id: '',
        details: [],
        status: 'draft',
      },
      formDetail: {},
      originalQtyB: 0,
      originalQtyS: 0,
      listDeleted: [],
      PurchaseOrder: [],
      containModesOption: [
        { label: 'Contains', value: FilterMatchMode.CONTAINS },
      ],
      equalModesOption: [{ label: 'Equals', value: FilterMatchMode.EQUALS }],
    }
  },
  computed: {
    list_status() {
      const list = [
        { value: 'draft', label: 'Draft', level: 0 },
        { value: 'done', label: 'Done', level: 1 },
      ]
      let old_status_level = 0
      if (this.old_status_value) {
        const status = list.find((e) => e.value === this.old_status_value)
        if (status) old_status_level = status.level
      }
      return list.map((status) => ({
        ...status,
        disabled: old_status_level > status.level,
      }))
    },
    list_produk() {
      return this.form.details.map((x) => `${x.rcv_id}${x.rcvd_id}`)
    },
    totalPO() {
      // Calculate purchase.disc_reg
      let discRegTotal = this.form.details.reduce((total, detail) => {
        total += detail.disc_regv
        return total
      }, 0)

      let discExtTotal = this.form.details.reduce((total, detail) => {
        total += detail.disc_extv
        return total
      }, 0)

      // jumlah bruto
      let bruto = this.form.details.reduce((total, detail) => {
        total += detail.bruto
        return total
      }, 0)

      // Calculate total_dpp
      let dpp = bruto - discRegTotal - discExtTotal

      let total_ppn = this.form.details.reduce((total, detail) => {
        total += detail.dpp * (detail.tax / 100)
        return total
      }, 0)

      total_ppn = Math.floor(total_ppn)

      const total = {
        bruto: bruto,
        dpp: dpp,
        disc_reg: discRegTotal,
        disc_ext: discExtTotal,
        ppn: total_ppn,
        total: dpp + total_ppn,
      }
      return total
    },
  },
  watch: {
    'form.supp_id'(value) {
      if (this.form.details.length > 0) {
        // cari detail pertama yang punya rcv_id
        const detailWithRcv = this.form.details.find((d) => d.rcv_id)

        if (detailWithRcv) {
          this.purchaseReceiveService
            .getById(`${detailWithRcv.rcv_id}`)
            .then((res) => {
              if (res.data.data.supp_id !== value) {
                this.dialogSupplier = true
                this.old_supplier_id = res.data.data.supp_id
              }
            })
            .catch((err) => {
              errorHandler(err, 'Data Supplier', this)
            })
        }
      }
    },
  },
  created() {
    this.purchaseReceiveService = new PurchaseReceiveService()
    this.purchaseReturService = new PurchaseReturService()
    this.supplierService = new SupplierService()
    this.satuanService = new SatuanService()
    this.settingService = new SettingService()
  },
  async mounted() {
    if (this.id > 0) {
      this.loadData()
    }

    this.supplierService
      .getActive()
      .then((res) => {
        this.list_supplier = res.data
      })
      .catch((err) => {
        errorHandler(err, 'Data Supplier', this)
      })
      .finally(() => (this.isLoading = false))

    this.satuanService
      .get()
      .then((res) => {
        this.list_satuan = res.data.data
      })
      .catch((err) => {
        errorHandler(err, 'Data Satuan', this)
      })
  },
  methods: {
    onCellEditComplete(event) {
      const { data, field, newValue } = event
      data[field] = newValue

      const totalDetail =
        data.rcvd_id && data.rcv_id
          ? this.totalDetail(data)
          : this.totalDetailNonPenerimaan(data)

      if (!totalDetail) {
        return
      }

      Object.assign(data, totalDetail)

      if (field === 'cost' && data.cost <= 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Retur',
          detail: 'Harga harus lebih dari 0',
          life: 3000,
        })
      }
    },
    handleEnter(data, field, event) {
      const result = this.calculateExpression(data[field])

      if (result === null) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Kalkulator',
          detail: 'Ekspresi matematika tidak valid',
          life: 3000,
        })
        return
      }

      data[field] = result
      event.target.blur()
    },
    calculateExpression(value) {
      if (typeof value === 'number') {
        return value
      }

      const expression = String(value ?? '')
        .replace(/\s+/g, '')
        .replace(/,/g, '.')

      if (!expression) {
        return 0
      }

      if (!/^[\d.+\-*/()%]+$/.test(expression)) {
        return null
      }

      try {
        const result = Function(`"use strict"; return (${expression})`)()

        if (!Number.isFinite(result)) {
          return null
        }

        return result
      } catch {
        return null
      }
    },
    totalDetail(detail) {
      let qty_b = Number(detail['qty_b']) || 0
      let qty_s = Number(detail['qty_s']) || 0
      const cost = Number(detail['cost']) || 0

      // hitung total qty
      let qty = 0
      if (qty_b > 0) {
        qty = detail['ubox'] * qty_b
      }
      qty += qty_s

      // hitung bruto & cost_s (izinkan 2 digit desimal)
      let cost_s = 0
      if (
        detail['cost_per'] === detail['unit_b'] &&
        detail['unit_b'] !== detail['unit_s'] &&
        detail['ubox'] > 0
      ) {
        cost_s = Number((cost / detail['ubox']).toFixed(2))
      } else {
        cost_s = Number(cost.toFixed(2))
      }

      let bruto = Number((cost_s * qty).toFixed(2))

      // disc reg
      let disc_regv = 0
      let disc_reg = Number(detail.disc_reg || 0)
      if (disc_reg <= 100) {
        disc_regv = Number((cost_s * (disc_reg / 100)).toFixed(2))
      } else {
        disc_regv = Number(disc_reg.toFixed(2))
      }

      cost_s = Number((cost_s - disc_regv).toFixed(2))
      if (cost_s < 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Retur',
          detail: 'Total diskon reguler tidak dapat melebihi harga satuan.',
          life: 3000,
        })
        return false
      }
      disc_regv = Number((disc_regv * qty).toFixed(2))

      // disc ext
      let disc_extv = 0
      let disc_ext = Number(detail.disc_ext || 0)
      if (disc_ext <= 100) {
        disc_extv = Number((cost_s * (disc_ext / 100)).toFixed(2))
      } else {
        disc_extv = Number(disc_ext.toFixed(2))
      }

      cost_s = Number((cost_s - disc_extv).toFixed(2))
      if (cost_s < 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Retur',
          detail: 'Total diskon extra tidak dapat melebihi harga satuan.',
          life: 3000,
        })
        return false
      }
      disc_extv = Number((disc_extv * qty).toFixed(2))

      let dpp = Number((cost_s * qty).toFixed(2))
      let total = dpp

      return {
        qty: qty,
        sunit: detail['sunit'],
        qty_b: qty_b,
        qty_s: qty_s,
        cost_per: detail['cost_per'],
        cost_s: cost_s,
        bruto: bruto,
        dpp: dpp,
        total: total,
        disc_regv: disc_regv,
        disc_extv: disc_extv,
      }
    },
    save(isFormValid) {
      this.submitted = true

      if (!isFormValid) {
        return
      }

      const deleted = this.id ? { deleted: this.listDeleted } : {}

      const rt_at = this.form.rt_at
        ? { rt_at: dayjs(this.form.rt_at).format('YYYY-MM-DD') }
        : null

      const form = {
        ...rt_at,
        rt_no: this.form.rt_no,
        ref_no: this.form.ref_no,
        supp_id: this.form.supp_id,
        status: this.form.status,
        details: this.form.details.map((item) => {
          // handle ID untuk update
          const id = item.id ? { id: item.id } : this.id ? { id: 0 } : {}

          if (item.rcvd_id) {
            // === penerimaan ===
            return {
              ...id,
              rcvd_id: item.rcvd_id,
              qty_b: item.qty_b,
              qty_s: item.qty_s,
              cost: item.cost,
            }
          } else {
            // === non penerimaan ===
            return {
              ...id,
              rcvd_id: 0,
              item_id: item.item_id,
              unit_b: item.unit_b,
              unit_s: item.unit_s,
              cost_per: item.cost_per,
              ubox: item.ubox,
              qty_b: item.qty_b,
              qty_s: item.qty_s,
              cost: item.cost,
              disc_reg: item.disc_reg ?? 0,
              disc_ext: item.disc_ext ?? 0,
              tax: item.tax ?? 0,
            }
          }
        }),
        ...deleted,
      }

      if (!this.id) {
        this.isLoadingSave = true
        this.purchaseReturService
          .add(form)
          .then((res) => {
            if (res.data.status === 1) {
              this.$toast.add({
                severity: 'success',
                summary: 'Retur',
                detail: 'Data berhasil disimpan.',
                life: 3000,
              })

              this.$router.push({ name: 'PurchaseRetur' })
            }
          })
          .catch((err) => {
            errorHandler(err, 'Retur', this)
          })
          .finally(() => {
            this.deleted = []
            this.isLoadingSave = false
          })
      } else {
        this.isLoadingSave = true
        this.purchaseReturService
          .update(this.id, form)
          .then((res) => {
            if (res.data.status === 1) {
              this.loadData()
              this.$toast.add({
                severity: 'success',
                summary: 'Retur',
                detail: 'Data berhasil diupdate.',
                life: 3000,
              })
              if (this.form.status === 'done') {
                this.$router.push({ name: 'PurchaseRetur' })
              }
            }
          })
          .catch((err) => {
            errorHandler(err, 'Retur', this)
          })
          .finally(() => {
            this.isLoadingSave = false
          })
      }
    },
    formatCurrency(val, minDigit = 2, maxdigit = 2) {
      return formatCurrency(val, minDigit, maxdigit)
    },
    formatPercentage(val, minDigit = 0, maxDigit = 0) {
      return formatPercentage(val, minDigit, maxDigit)
    },

    loadData() {
      this.isLoading = true
      this.purchaseReturService
        .getById(this.id)
        .then((res) => {
          this.form = res.data.data
          this.form.rt_at = this.form.rt_at ? new Date(this.form.rt_at) : ''
          this.old_status_value = this.form.status
          this.isLoading = false
        })
        .catch((err) => {
          errorHandler(err, 'Data Retur', this)
        })
        .finally(() => (this.isLoading = false))
    },

    onEditData(data) {
      this.editMode = true
      this.formDetail = Object.assign({}, data)
      this.originalQtyB = data.qty_b
      this.originalQtyS = data.qty_s
      this.dialogItem = true
    },
    onAddData() {
      this.editMode = false

      if (!this.form.supp_id) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Retur',
          detail: 'Supplier harus diisi terlebih dahulu.',
          life: 3000,
        })
        return
      }

      this.isLoadingItem = true
      this.purchaseReceiveService
        .getBy(`?status=printed,posted&supp_id=${this.form.supp_id}&return=0`)
        .then((res) => {
          this.list_purchase_order = res.data.data
          this.dialog = true
          this.isLoadingItem = false
          // }
        })
        .catch(() => {
          this.isLoadingItem = false
        })
    },
    async onSaveDataItem(data) {
      const detailItem = { ...data }

      let idx = -1
      let totalDetail = {}

      if (detailItem.rcvd_id && detailItem.rcv_id) {
        // kasus penerimaan
        idx = this.form.details.findIndex(
          (item) =>
            item.rcvd_id === detailItem.rcvd_id &&
            item.rcv_id === detailItem.rcv_id
        )
        totalDetail = await this.totalDetail(detailItem)
      } else {
        // kasus non penerimaan
        idx = this.form.details.findIndex(
          (item) =>
            !item.rcvd_id && !item.rcv_id && item.item_id === detailItem.item_id
        )
        totalDetail = await this.totalDetailNonPenerimaan(detailItem)
      }

      if (this.editMode) {
        if (idx !== -1) {
          Object.assign(this.form.details[idx], {
            ...detailItem,
            ...totalDetail,
          })
        } else {
          this.form.details.push({ ...detailItem, ...totalDetail })
        }
      } else {
        this.form.details.push({ ...detailItem, ...totalDetail })
      }

      this.dialogItem = false
    },
    async onSaveData(data) {
      for (const detailItem of data) {
        let idx = -1

        if (detailItem.rcvd_id && detailItem.rcv_id) {
          // kasus penerimaan
          idx = this.form.details.findIndex(
            (item) =>
              item.rcvd_id === detailItem.rcvd_id &&
              item.rcv_id === detailItem.rcv_id
          )
        } else {
          // kasus non penerimaan
          idx = this.form.details.findIndex(
            (item) =>
              !item.rcvd_id &&
              !item.rcv_id &&
              item.item_id === detailItem.item_id
          )
        }

        const totalDetail = await this.totalDetail(detailItem)

        if (idx === -1) {
          delete detailItem.id
          this.form.details.push({ ...detailItem, ...totalDetail })
          this.$toast.add({
            severity: 'success',
            summary: 'Retur',
            detail: 'Data Item berhasil ditambahkan.',
            life: 3000,
          })
          this.dialog = false
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Retur',
            detail: `Item ${detailItem.item_name} sudah ada dalam daftar retur.`,
            life: 3000,
          })
        }
      }
    },
    onAddDataNonPenerimaan() {
      if (!this.form.supp_id) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Retur',
          detail: 'Supplier harus diisi terlebih dahulu.',
          life: 3000,
        })
        return
      }
      this.formDetail = {
        item_id: '',
        unit_b: '',
        unit_s: '',
        cost_per: '',
        ubox: '',
        qty_b: 0,
        qty_s: 0,
        cost: 0,
        disc_reg: 0,
        disc_ext: 0,
        tax: 0,
      }
      this.dialogNonPenerimaan = true
    },
    async onSaveDataItemNonPenerimaan(data) {
      const detailItem = {
        ...data,
        rcv_no: null,
        rcv_id: null,
        rcvd_id: null,
      }

      const idx = this.form.details.findIndex(
        (item) =>
          !item.rcvd_id && !item.rcv_id && item.item_id === detailItem.item_id
      )

      if (idx !== -1) {
        this.$toast.add({
          severity: 'error',
          summary: 'Retur',
          detail: `Item ${detailItem.item_name} sudah ada dalam daftar retur.`,
          life: 3000,
        })
        this.dialogNonPenerimaan = false
        return
      }

      const totalDetail = await this.totalDetailNonPenerimaan(detailItem)
      delete detailItem.id
      this.form.details.push({ ...detailItem, ...totalDetail })

      this.$toast.add({
        severity: 'success',
        summary: 'Retur',
        detail: 'Data Item berhasil ditambahkan.',
        life: 3000,
      })

      this.dialog = false
      this.dialogNonPenerimaan = false
    },
    totalDetailNonPenerimaan(detail) {
      let qty_b = Number(detail['qty_b']) || 0
      let qty_s = Number(detail['qty_s']) || 0
      const cost = Number(detail['cost']) || 0

      // hitung total qty
      let qty = 0
      if (qty_b > 0) {
        qty = detail['ubox'] * qty_b
      }
      qty += qty_s

      // hitung bruto & cost_s (izinkan 2 digit desimal)
      let cost_s = 0
      if (
        detail['cost_per'] === detail['unit_b'] &&
        detail['unit_b'] !== detail['unit_s'] &&
        detail['ubox'] > 0
      ) {
        cost_s = Number((cost / detail['ubox']).toFixed(2))
      } else {
        cost_s = Number(cost.toFixed(2))
      }

      let bruto = Number((cost_s * qty).toFixed(2))

      // disc reg
      let disc_regv = 0
      let disc_reg = Number(detail.disc_reg || 0)
      if (disc_reg <= 100) {
        disc_regv = Number((cost_s * (disc_reg / 100)).toFixed(2))
      } else {
        disc_regv = Number(disc_reg.toFixed(2))
      }

      cost_s = Number((cost_s - disc_regv).toFixed(2))
      if (cost_s < 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Retur',
          detail: 'Total diskon reguler tidak dapat melebihi harga satuan.',
          life: 3000,
        })
        return false
      }
      disc_regv = Number((disc_regv * qty).toFixed(2))

      // disc ext
      let disc_extv = 0
      let disc_ext = Number(detail.disc_ext || 0)
      if (disc_ext <= 100) {
        disc_extv = Number((cost_s * (disc_ext / 100)).toFixed(2))
      } else {
        disc_extv = Number(disc_ext.toFixed(2))
      }

      cost_s = Number((cost_s - disc_extv).toFixed(2))
      if (cost_s < 0) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Retur',
          detail: 'Total diskon extra tidak dapat melebihi harga satuan.',
          life: 3000,
        })
        return false
      }
      disc_extv = Number((disc_extv * qty).toFixed(2))

      let dpp = Number((cost_s * qty).toFixed(2))
      let total = dpp

      let price = Number((cost_s / (1 - detail['item_mrg'] / 100)).toFixed(2))
      let ppn = Math.floor(price * (detail['tax'] / 100))
      price = ceiling(price + ppn)

      return {
        qty: qty,
        bruto: bruto,
        dpp: dpp,
        total: total,
        price: price,
        cost_s: cost_s,
        disc_regv: disc_regv,
        disc_extv: disc_extv,
      }
    },
    onConfirmDeletion(data) {
      this.formDetail = data
      this.dialogHapus = true
    },
    onDeleteItemPurchaseOrder() {
      const index = this.form.details.findIndex(
        (el) => el.item_id === this.formDetail.item_id
      )
      if (index !== -1) {
        if (this.id && this.form.details[index].id) {
          this.listDeleted.push(this.form.details[index].id)
        }
        this.form.details.splice(index, 1)
        this.$toast.add({
          severity: 'success',
          summary: 'Data Item Retur',
          detail: 'Data berhasil dihapus.',
          life: 3000,
        })
      }
      this.dialogHapus = false
    },
    onYesSupplier() {
      this.form.details = []
      this.dialogSupplier = false
    },
    onNoSupplier(value) {
      this.$refs.supplierDropdown.filterValue = ''
      this.form.supp_id = value
      this.dialogSupplier = false
    },
    onTriggerHotkey(payload) {
      if (payload.keyString === 'D') {
        this.onAddData()
      }
    },
    /* onToggle(value) {
      this.selectedColumns = this.columns.filter((col) => value.includes(col))
    }, */
  },
  validations() {
    return {
      form: {
        supp_id: {
          required: helpers.withMessage('Supplier harus diisi.', required),
        },
      },
    }
  },
}
</script>
